declare namespace Serenity {

    const enum ColumnSelection {
        List = 0,
        KeyOnly = 1,
        Details = 2
    }
    
    const enum RetrieveColumnSelection {
        details = 0,
        keyOnly = 1,
        list = 2
    }
}